module.exports = __webpack_public_path__ + "img/horizontal_7_4_8003.04cc5281.png";